import React, { useState } from "react";
import { Button, ControlLabel, FormGroup, Glyphicon, ListGroupItem } from "react-bootstrap";
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";
import clone from "lodash.clonedeep";
import * as FilesApi from "../../../../../../api/cp/memberFile";
import MaterialsUpdateModal from "../../../EpisodesPage/EditModals/MaterialsUpdateModal";
import cloneDeep from "lodash.clonedeep";

const ParticipantMaterials = ({ member }) => {
    const [files, setFiles] = useState((member?.files || []).slice().sort((a, b) => (a.sortOrder - b.sortOrder)));
    const [editableMaterial, setEditableMaterial] = useState(null);
    const [isMaterialsModalVisible, setMaterialsModalVisible] = useState(false);

    const handleFileCreate = async (file) => {
        try {
            const response = await FilesApi.createMemberFile(member.id, file);
            setFiles((prevState) => [...prevState, response]);
        } catch (error) {
            console.error(error);
        }
    };

    const handleFileUpdate = async (updatedFile) => {
        try {
            const file = await FilesApi.updateMemberFile(updatedFile.id, updatedFile);
            setFiles(prev => prev.map(f => f.id === file.id ? ({...f, ...file}) : f))            
        } catch (error) {
            console.error(error);
        }
    };

    const handleFileDelete = async (id) => {
        try {
            await FilesApi.deleteMemberFile(id);
            setFiles(files.filter((file) => file.id !== id));
        } catch (error) {
            console.error(error);
        }
    };

    const handleEditFile = (file) => {
        setEditableMaterial(file);
        setMaterialsModalVisible(true);
    }

    const updateFilesList = async (list) => {
        const _files = cloneDeep(files);
        try {
            setFiles(list);
            const payload = list.map(({ id }) => id);
            await FilesApi.updateMemberFilesOrder(member.id, payload);
        } catch (error) {
            console.error(error);
            setFiles(_files);
        }
    };

    function onDragEnd(result) {
        if (!result.destination) {
            return;
        }

        const reorderedFiles = reorder(
            files,
            result.source.index,
            result.destination.index,
        );

        updateFilesList(reorderedFiles);
    };

    function reorder(list, startIndex, endIndex) {
        const result = clone(list);
        const [removed] = result.splice(startIndex, 1);
        result.splice(endIndex, 0, removed);

        return result;
    }

    return (
        <section style={{ marginTop: '12px' }}>
            <FormGroup>
                <ControlLabel>Материалы</ControlLabel>
                <DragDropContext onDragEnd={onDragEnd}>
                    <Droppable droppableId="droppable">
                        {(provided) => (
                            <div
                                {...provided.droppableProps}
                                ref={provided.innerRef}
                            >
                                {files?.map((file, index) => (
                                    <Draggable
                                        key={file.id}
                                        draggableId={`${file.id || index}`}
                                        index={index}
                                    >
                                        {(provided) => (
                                            <div
                                                ref={provided.innerRef}
                                                {...provided.draggableProps}
                                                {...provided.dragHandleProps}
                                                style={
                                                    provided.draggableProps.style
                                                }
                                            >
                                                <ListGroupItem>
                                                    <PFile
                                                        file={file}
                                                        onUpdate={handleEditFile}
                                                        onDelete={handleFileDelete}
                                                    />
                                                </ListGroupItem>
                                            </div>
                                        )}
                                    </Draggable>
                                ))}
                                {provided.placeholder}
                            </div>
                        )}
                    </Droppable>
                </DragDropContext>
                <Button
                    style={{ marginTop: '12px' }}
                    onClick={() => setMaterialsModalVisible(true)}
                >
                    Добавить материалы
                </Button>
            </FormGroup>

            <MaterialsUpdateModal
                show={isMaterialsModalVisible}
                editableMaterial={editableMaterial}
                onUpdate={handleFileUpdate}
                onSave={handleFileCreate}
                onClose={() => setMaterialsModalVisible(false)}
            />
        </section>
    );
};

const PFile = (
    {
        file,
        onDelete,
        onUpdate,
    }
) => {
    if (!file) return null;

    const fileExtension = file.extension?.toUpperCase();

    return (
        <div className="episode-file">
            <span>{fileExtension}</span>
            <span>
                <b>{file.titleRu || file.titleEn}</b>
            </span>
            <div className="episode-file__buttons">
                {!file.link && (
                    <Button href={file.url} target="_blank"><Glyphicon glyph="download" /></Button>
                )}
                <Button onClick={() => onUpdate(file)}><Glyphicon glyph="edit" /></Button>
                <Button onClick={() => onDelete(file.id)} bsStyle="danger"><Glyphicon glyph="trash" /></Button>
            </div>
        </div>
    );
};

export default ParticipantMaterials;
